import JSZip from "jszip";
import { partitionByPaper } from "./partitionByPaper";
import { renderPaperPdfBlob } from "./SheetComposerPdf";
import { PAPER_ORDER, bucketForVisual } from "./labelTemplates";
import { chunkIntoPages, perPageFor } from "./sheetComposer";
import { formatLocalDate, unifiedPdfName, pagePdfPath } from "./tagZipNames";

const enrichCard = (card) => {
  const part = partitionByPaper(card);
  return {
    ...card,
    scenario: part.scenario,
    visual: part.visual,
    paper: part.paper,
    invertida: part.invertidaEffective,
    bucket: bucketForVisual(part.visual),
  };
};

/** Agrupa pelo papel de estoque V1 (dourado / majorca / colorido). */
const groupByPaper = (cards) => {
  const groups = {};
  for (const card of cards) {
    const enriched = enrichCard(card);
    if (!groups[enriched.paper]) groups[enriched.paper] = [];
    groups[enriched.paper].push(enriched);
  }
  return groups;
};

/** Compat: ainda chamado em testes antigos; delega ao agrupamento por papel. */
const groupByBucket = (cards) => {
  const byPaper = groupByPaper(cards);
  const byBucket = {};
  for (const list of Object.values(byPaper)) {
    for (const card of list) {
      if (!byBucket[card.bucket]) byBucket[card.bucket] = [];
      byBucket[card.bucket].push(card);
    }
  }
  return byBucket;
};

async function buildTagsZip(selectedCards, options = {}) {
  const unifyPages = options.unifyPages === true;
  const date = options.date || formatLocalDate();
  const { geometry, resolveArtUrl } = options;
  const groups = groupByPaper(selectedCards);
  const zip = new JSZip();
  const files = [];

  // `geometry` só importa para o papel "art" (slots calculados); os papéis
  // legados (dourado/majorca/colorido) ignoram o campo dentro do template.
  for (const paper of PAPER_ORDER) {
    const cards = groups[paper];
    if (!cards?.length) continue;

    if (unifyPages) {
      const pdfBlob = await renderPaperPdfBlob(cards, { paper, geometry, resolveArtUrl });
      const filename = unifiedPdfName(paper, date);
      zip.file(filename, pdfBlob);
      files.push(filename);
      continue;
    }

    const pages = chunkIntoPages(cards, perPageFor(paper));
    for (let i = 0; i < pages.length; i++) {
      const pdfBlob = await renderPaperPdfBlob(pages[i], { paper, geometry, resolveArtUrl });
      const filename = pagePdfPath(paper, i + 1, date);
      zip.file(filename, pdfBlob);
      files.push(filename);
    }
  }

  const blob = await zip.generateAsync({ type: "blob" });
  return { blob, files };
}

export { buildTagsZip, groupByPaper, groupByBucket, enrichCard };
